import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import { createTheme , ThemeProvider } from '@material-ui/core';

const theme = createTheme ({
  palette: {
    primary: {
      main: "#003E52",
      warning: "#FF4438"
    },
    secondary: {
      main: "#FF4438",
      contrastText: "#FF4438",
    },
    text: {
      primary: "#003E52",
      warning: "#FF4438"
    }
  },
  overrides: {
    MuiButton: {
      label: {
        textTransform: "none",
      }
    }
  },
  typography: {
    fontFamily: "'Lato', sans-serif",
    fontWeightRegular: "bold",
  }
});

/**
 * Wraps the component in router and renders
 */
const render = (Component) => {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <Router>
        <Component/>
      </Router>
    </ThemeProvider>,
    document.getElementById("root"),
  );
}

// render the main app
render(App);

// disable PWA
serviceWorker.unregister();
